import { Injectable } from '@angular/core';
import { TransponderVendor, BaseResponseDTO, DefaultService } from "@psnb/psnb-api";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TransponderVendorService {

  constructor(private powerSupplyService: DefaultService) {
  }

  getAllVendorsFromService() {
    return this.powerSupplyService.getTransponderVendors().pipe(map(result => result));
  }

  createTransponderVendor(transponderVendor: TransponderVendor){
    return this.powerSupplyService.createTransponderVendor(transponderVendor).pipe(map(result => result));
  }

  updateTransponderVendor (transponderVendor: TransponderVendor){
    return this.powerSupplyService.updateTransponderVendor(transponderVendor).pipe(map(result => result));
  }

  deleteTransponderVendor(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteTransponderVendor(id).pipe(map(result => result));
  }

  getTransponderVendorsByRootId(rootId: number) {
    return this.powerSupplyService.getTransponderVendorsByRootId(rootId).pipe(map(result => result));
  }
}
